import { Button } from '@chakra-ui/react'
import React, { useState } from 'react'
import { HeaderLine, LinksContainer } from '../../../styles/ListingsStyles'

interface BottomLinksProps {
    listHeader: string
    list: any[]
    children: (prop: any, index: number) => React.ReactNode
}

function BottomLinks({
  list,
  listHeader,
  children
}: BottomLinksProps) {
  const listIsOver12Items = list.length > 12;
  const [listExpanded, setListingExpanded] = useState(false)

  const toggleListExpanded = () => {
    setListingExpanded(!listExpanded)
  }


  return (
    <>
        <HeaderLine>{listHeader} </HeaderLine>
        <LinksContainer>
            {list?.slice(0, listExpanded ? list.length : 12).map((l, i) => {
                return children(l, i)
              }
            )}
        </LinksContainer>
          {
            (listIsOver12Items) && (
              <Button 
                mt="15px" 
                variant="link" 
                textDecor={'underline'} 
                color="green.500" 
                size="xs" 
                onClick={toggleListExpanded}
                w="fit-content">
                  Show {listExpanded ? "less" : "more"}
              </Button>
            )
          }
    </>
  )
}

export default BottomLinks